export default "__VITE_ASSET__cdfb18e3__"